// src/features/dashboard/components/ManagerDashboard/AtRiskAssociate/FourWeekTrendChart.tsx

import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
} from 'recharts';

import useAtRiskAssociates from '../../../hooks/Manager/AtRiskAssociates/useAtRiskAssociates';

interface Props {
  managerEmployeeCode: string;
}

const FourWeekTrendChart = ({
  managerEmployeeCode,
}: Props) => {

  const {
    riskTrend,
    loading,
    riskTrendError,
  } = useAtRiskAssociates({
    managerEmployeeCode,
  });

  const chartData = riskTrend.map(item => ({
    week: item.weekLabel,
    count: item.atRiskCount,
  }));

  if (loading) {
    return (
      <div className="bg-white border border-slate-200 rounded-2xl p-4 h-[300px] flex items-center justify-center">
        Loading...
      </div>
    );
  }

  if (riskTrendError) {
    return (
      <div className="bg-white border border-slate-200 rounded-2xl p-4 h-[300px] flex items-center justify-center text-red-500">
        {riskTrendError}
      </div>
    );
  }

  return (
    <div className="bg-white border border-slate-200 rounded-2xl p-4 h-[300px]">
      <div className="flex items-center gap-2 mb-3">
        <h3 className="text-[15px] font-semibold text-[#003E7E]">
          4-Week Trend
        </h3>

        <span className="bg-blue-50 text-blue-600 text-[10px] px-3 py-1 rounded-full">
          At-risk count
        </span>
      </div>

      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={chartData}>
          <CartesianGrid
            vertical={false}
            strokeDasharray="3 3"
          />

          <XAxis
            dataKey="week"
            tick={{ fontSize: 11 }}
          />

          <YAxis
            tick={{ fontSize: 11 }}
          />

          <Tooltip />

          <Line
            type="monotone"
            dataKey="count"
            stroke="#ef4444"
            strokeWidth={2}
            dot={{
              r: 4,
              fill: '#ef4444',
            }}
            label={{
              position: 'top',
              fill: '#ef4444',
              fontSize: 11,
            }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FourWeekTrendChart;